<template>
  <div>
    <message-loading />
    <message-loading :is-right="true" />
    <message-loading />
    <message-loading :is-right="true" />
    <message-loading />
  </div>
</template>

<script>
import MessageLoading from "./Message";
export default {
  name: "Loading",
  components: { MessageLoading },
};
</script>
